import React, { useCallback, useState } from "react";
import { UserPassword } from "../../../domain/user/UserPassword";
import { useAppDispatch } from "../../../state/store";
import { changePasswordAction } from "../../../state/usecase/change_password/actions";
import { Button } from "../common/button/Button";
import { InputTextBox } from "../common/input/InputTextBox";

export const PasswordInput = React.memo(function PasswordInput() {
    const dispatch = useAppDispatch();

    const [password, setPassword] = useState("");

    const [confirmPassword, setConfirmPassword] = useState("");

    const [lengthError, setLengthError] = useState(false);

    const [confirmError, setConfirmError] = useState(false);

    const validationOk = useCallback((password: string, confirmPassword: string) => {
        const userPassword = UserPassword.fromString(password);

        const lengthError = !userPassword.isValidLength();
        setLengthError(lengthError);

        const confirmError = !userPassword.isConfirmOk(confirmPassword);
        setConfirmError(confirmError);

        return !(lengthError || confirmError);
    }, []);

    const changeButtonClicked = useCallback(() => {
        if (validationOk(password, confirmPassword)) {
            dispatch(
                changePasswordAction({
                    password: UserPassword.fromString(password)
                })
            );
        }
    }, [password, confirmPassword, validationOk, dispatch]);

    return (
        <div className={"content"}>
            <div className={"input_area"}>
                <div className={"label"}>新しいパスワード（12文字以上）</div>
                <div className={"error_message"}>{lengthError && "パスワードは12文字以上で入力してください。"}</div>
                <InputTextBox
                    isPassword
                    value={password}
                    handleTextChanged={setPassword}
                    hasError={lengthError}
                />
            </div>
            <div className={"input_area"}>
                <div className={"label"}>新しいパスワード（確認用）</div>
                <div className={"error_message"}>{confirmError && "確認用パスワードが違います。"}</div>
                <InputTextBox
                    isPassword
                    value={confirmPassword}
                    handleTextChanged={setConfirmPassword}
                    hasError={confirmError}
                />
            </div>
            <Button label={"変更"} onClick={changeButtonClicked} />
        </div>
    );
});
